import React from "react";
import {Link, useNavigate} from "react-router-dom";
import {useTranslation} from "../../i18n/LanguageProvider";

export default function DiscoveryLinks({onNavigate}: {onNavigate?: () => void}) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const itemClass = "inline-flex min-h-[44px] items-center justify-center gap-1.5 whitespace-nowrap rounded-full px-3 py-2 text-xs font-bold transition hover:bg-[#EEE5FF] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#712FFF] sm:gap-2 sm:px-4 sm:text-sm";
  return <nav aria-label={t("discover.navigation")} className="flex flex-wrap items-center justify-center gap-1 rounded-3xl border border-[#E9E0F6] bg-white/90 p-1.5 text-[#69429F] sm:gap-2">
    <button type="button" onClick={() => {onNavigate?.(); navigate("/surprise");}} className={`${itemClass} bg-[#F2EBFF] text-[#712FFF]`}><span aria-hidden="true">🎲</span>{t("discover.surprise")}</button>
    <Link to="/weekends" onClick={onNavigate} className={itemClass}><span aria-hidden="true">🌤️</span>{t("discover.weekend")}</Link>
  </nav>;
}
